import "./products.css";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { Button, Card, Divider, Flex, Image, Modal, notification, Space } from "antd";
import editIcon from "../../Images/Edit.svg";
import enableIcon from "../../Images/EnableIcon.svg";
import { MenuService } from "deliziora-client-module/client-web";
import deleteIcon from "../../Images/Delete.svg";
import StarEspeciality from "../../ImageComponents/StarEspeciality";
import StarIcon from "../../ImageComponents/StarIcon";
import { isMobile } from "react-device-detect";

export default function ProductsComponent({
  callBackClickEditProduct,
  callBackClickDeleteProduct,
  callBackClickEspecialityProduct,
  callBackClickMenuCompleteProduct,
  callBackClickRemoveMenuCompleteProduct,
  products,
  isLoading,
}) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const handleEditButton = (product) => {
    callBackClickEditProduct(product);
  };
  const deletePlate = (id) => {
    callBackClickDeleteProduct(id);
  };

  const addEspeciality = (plateName) => {
    callBackClickEspecialityProduct(plateName);
  };
  const addMenuComplete = (plate) => {
    callBackClickMenuCompleteProduct(plate);
  };
  const RemoveMenuComplete = (plate) => {
    callBackClickRemoveMenuCompleteProduct(plate);
  };

  return (
    <> {isMobile === true ? (
      <Flex vertical align="center" justify="center" >
        {products.map((product) => {
          return (
            <Flex vertical align="center" justify="center" gap={10}>
              <Flex vertical align="center" justify="center"  gap={10} style={{
                width: "100%",
              }}>
                <Flex align="center" justify="center" flex={3} gap={5}>
                  <Flex>{product.name}</Flex>
                  <Flex>€{product.price}</Flex>
                </Flex>
                <Flex flex={1} align="center" justify="center">
                  <Flex gap={5} vertical align="center" justify="center">

                    <Flex align="center" justify="center" gap={5} style={{
                      margin: "auto",
                    }}>
                      <Image
                        preview={false}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                        src={deleteIcon}
                        onClick={() => {
                          Modal.confirm({
                            title: "Confirmação",
                            content: "Você realmente deseja excluir este prato?",
                            onOk() {
                              deletePlate(product._id.$oid);
                            },
                          });
                        }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      <Image preview={false}
                        src={editIcon}
                        onClick={() => {
                          handleEditButton(product);
                        }}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      <Image preview={false}
                        src={enableIcon}
                        onClick={() => { }}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      {product.name === userData.especialty ? (
                        <Flex className="star_icon_especialty">
                          <StarEspeciality />
                        </Flex>
                      ) : (
                        <Flex
                          className="star_icon"
                          onClick={() => {
                            addEspeciality(product.name);
                          }}
                        >
                          <StarIcon height={"23"} width={"23"} />
                        </Flex>
                      )}
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                    </Flex>

                    {product.menu_complete ? (
                      <Button
                        onClick={() => {
                          RemoveMenuComplete(product);
                        }}
                        style={{
                          width: "100%",
                          height: 30,
                          fontSize: 14,
                          alignItems: "center",
                          justifyContent: "center",
                          background: "black",
                          color: "white",
                          borderRadius: "100px",
                        }}
                      >
                        Remover do Menu Completo
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          addMenuComplete(product);
                        }}
                        style={{
                          width: "100%",
                          height: 30,
                          fontSize: 14,
                          alignItems: "center",
                          justifyContent: "center",
                          background: "black",
                          color: "white",
                          borderRadius: "100px",
                        }}
                      >
                        Tornar Menu Completo
                      </Button>
                    )}
                  </Flex>
                </Flex>
              </Flex>
              <Divider />
            </Flex>
          );
        })}
      </Flex>)
      :
      (

        <Flex vertical className="box_product_container" >
          {products.map((product) => {
            return (
              <>
                <Flex justify={"space-between"}>
                  <Flex justify={"space-around"} flex={3}>
                    <Flex>{product.name}</Flex>
                    <Flex>€{product.price}</Flex>
                  </Flex>
                  <Flex flex={1}>
                    <Flex gap={5}>
                      <Image
                        preview={false}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                        src={deleteIcon}
                        onClick={() => {
                          Modal.confirm({
                            title: "Confirmação",
                            content: "Você realmente deseja excluir este prato?",
                            onOk() {
                              deletePlate(product._id.$oid);
                            },
                          });
                        }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      <Image preview={false}
                        src={editIcon}
                        onClick={() => {
                          handleEditButton(product);
                        }}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      <Image preview={false}
                        src={enableIcon}
                        onClick={() => { }}
                        style={{ width: 23, height: 23, cursor: "pointer" }}
                      />
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      {product.name === userData.especialty ? (
                        <Flex className="star_icon_especialty">
                          <StarEspeciality />
                        </Flex>
                      ) : (
                        <Flex
                          className="star_icon"
                          onClick={() => {
                            addEspeciality(product.name);
                          }}
                        >
                          <StarIcon height={"23"} width={"23"} />
                        </Flex>
                      )}
                      <Divider type="vertical" style={{
                        width: "100%",
                        height: "100%",
                      }} />
                      {product.menu_complete ? (
                        <Button
                          onClick={() => {
                            RemoveMenuComplete(product);
                          }}
                          style={{
                            width: "100%",
                            height: 30,
                            fontSize: 14,
                            alignItems: "center",
                            justifyContent: "center",
                            background: "black",
                            color: "white",
                            borderRadius: "100px",
                          }}
                        >
                          Remover do Menu Completo
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            addMenuComplete(product);
                          }}
                          style={{
                            width: "100%",
                            height: 30,
                            fontSize: 14,
                            alignItems: "center",
                            justifyContent: "center",
                            background: "black",
                            color: "white",
                            borderRadius: "100px",
                          }}
                        >
                          Tornar Menu Completo
                        </Button>
                      )}
                    </Flex>
                  </Flex>
                </Flex>
                <Divider />
              </>
            );
          })}
        </Flex>)}

    </>
  );
}
